let filter = Object.freeze({
    "feilds": [
        {
            id: 1,
            name: 'unit',
            text: 'Unit',
            visible: true,
            element: 'select2',
            required: true,
            input_type: 'select',
            placeholder: 'Unit',
            icon: 'user',
            rules: [
                {
                    test: (value) => {

                        return (value !== null && value.length > 0);
                    },
                    message: 'Please Select Your Unit'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            relation: false,
            relationvalue: [],
            className: 'col'
        }, {
            id: 3,
            name: 'new_service_id',
            text: 'Service',
            relation: true,
            relationvalue: ['unit', 'department', 'service_group'],
            visible: true,
            element: 'select2',
            required: true,
            input_type: 'select',
            placeholder: 'Service',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        return (value !== null && value.length > 0);
                        //return true;
                    },
                    message: 'Please Select Your Service'
                }, {
                    verify: (filtereData) => {
                        let data = false;
                        if (filtereData !== undefined) {
                            filtereData.map((feild, key) => {

                                if (feild.name === 'unit' && feild.value !== null) {
                                    data = true;
                                }

                            })
                            if (data) {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    },
                    message: 'Please Select Department'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col'
        }, {
            id: 2,
            name: 'department',
            text: 'Department',
            visible: true,
            element: 'select2',
            required: true,
            input_type: 'select',
            placeholder: 'Department',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        return (value !== null && value.length > 0);
                    },
                    message: 'Please Select Your Department'
                }],
            errors: [],
            value: null,
            valid: false,
            relation: true,
            relationvalue: ['unit'],
            state: '',
            disable: true,
            className: 'col'
        }, {
            id: 3,
            name: 'service_group',
            text: 'Service Group',
            relation: true,
            relationvalue: ['unit', 'department'],
            visible: true,
            element: 'select2',
            required: true,
            input_type: 'select',
            placeholder: 'Service Group',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        return (value !== null && value.length > 0);
                    },
                    message: 'Please Select Your Service Group'
                }],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col'
        }, {
            id: 4,
            name: 'doctor',
            text: 'Doctor',
            relation: true,
            relationvalue: ['unit', 'department', 'service_id','new_service_id'],
            visible: true,
            element: 'select2',
            required: true,
            input_type: 'select',
            placeholder: 'Doctor',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        return (value !== null && value.length > 0);
                    },
                    message: 'Please Select Your Doctor'
                }, {
                    verify: (filtereData) => {
                        let data = false;
                        if (filtereData !== undefined) {
                            filtereData.map((feild, key) => {

                                if (feild.name === 'service_group' && feild.value !== null) {

                                    data = true;
                                }

                            })
                            if (data) {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    },
                    message: 'Please Select Department'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col'
        }, {
            id: 5,
            name: 'date',
            text: 'Date',
            visible: true,
            element: 'date',
            required: true,
            input_type: 'date',
            placeholder: 'Select Date',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        return (value !== null && value.length > 0);
                    },
                    message: 'Please Select Your Appointment Date'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col'
        }, {
            id: 0,
            name: 'button',
            text: 'GO',
            visible: true,
            required: false,
            element: 'button',
            input_type: 'button',
            disable: false,
            className: 'col-1'
        }
    ]
});
let patientType = null;
let formData = Object.freeze({
    "feilds": [
        {
            id: 1,
            name: 'umr',
            text: 'UMR Number',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'text',
            placeholder: 'UMR Number',
            icon: 'search',
            rules: [
                {
                    test: (value) => {
                        // return (value !== null && value.length > 0)
                        return true;
                    },
                    message: 'Please Enter Your UMR'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4'
        }, {
            id: 2,
            name: 'mobile',
            text: 'Mobile Number',
            visible: true,
            icon: 'search',
            element: 'input',
            required: true,
            input_type: 'number',
            placeholder: 'Mobile Number',
            rules: [
                {
                    test: (value) => {
                        var regex = /^\d{10}$/g;


                        if (value !== null && value.length > 0 && regex.test(value) === false) {
                            return false;
                        } else {
                            return true;
                        }
                    },
                    message: 'Please Enter valid Mobile Number'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4'
        }, {
            id: 3,
            name: 'ipnumber',
            text: 'IP Number',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'text',
            placeholder: 'IP Number',
            icon: 'search',
            rules: [
                {
                    test: (value) => {
                        //return (value !== null && value.length > 0);
                        return true;
                    },
                    message: 'Please Enter Your IP Number'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4'
        }, {
            id: 4,
            name: 'patient_list',
            text: 'Patient List',
            visible: true,
            element: 'select2',
            required: true,
            input_type: 'select',
            placeholder: 'Patient List',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        //return (value !== null && value.length > 0);
                        return true;
                    },
                    message: 'Please Select Your patient list'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-12'
        }, {
            id: 5,
            name: 'name',
            text: 'Patient Name',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'text',
            placeholder: 'Patient Name',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        return (value !== null && value.length > 0);
                    },
                    message: 'Please Enter Your Name'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4'
        }, {
            id: 6,
            name: 'phonenumber',
            text: 'Mobile Number',
            visible: true,
            icon: 'user',
            element: 'input',
            required: true,
            input_type: 'number',
            placeholder: 'Mobile Number',
            rules: [
                {
                    test: (value) => {
                        var regex = /^\d{10}$/g;


                        if (value !== null && value.length > 0 && regex.test(value) === false) {
                            return false;
                        } else {
                            return true;
                        }
                    },
                    message: 'Please Enter valid Mobile Number'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4'
        }, {
            id: 7,
            name: 'umr_number',
            text: 'UMR Number',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'text',
            placeholder: 'UMR Number',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        //return (value !== null && value.length > 0);
                        return true;
                    },
                    message: 'Please Enter Your UMR'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4'
        }, {
            id: 8,
            name: 'patient_type',
            text: 'Patient Type',
            visible: true,
            element: 'select2',
            required: true,
            input_type: 'select',
            placeholder: 'Patient Type',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        return (value !== null && value.length > 0);
                    },
                    message: 'Please Select Your patient type'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-6'
        }, {
            id: 22,
            name: 'nurse_station_number',
            text: 'Nurse Station',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'text',
            placeholder: 'Nurse Station',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        if(patientType !== null){
                            return (value !== null && value.length > 0);
                        }else{
                            return true;
                        }
                        
                    },
                    message: 'Please Enter Nurse Station'
                },
                {
                    verify: (filtereData) => {
                        let data = false;
                         patientType = null;
                        console.log(filtereData);
                        if (filtereData !== undefined) {
                            filtereData.map((feild, key) => {
                                if (feild.name === 'patient_type' && feild.value !== null && (feild.value === 'IP' || feild.value === 'bedside')) {
                                    patientType = feild.value;
                                }
                               
                            })
                            if (data) {
                                return true;
                            } else {
                                filtereData.map((feild, key) => {
                                    if (feild.name === 'nurse_station_number' && (patientType !== 'IP' || patientType !== 'bedside')) {
                                        filtereData[key]['disable'] = true;
                                    }
                                    if (feild.name === 'nurse_station_number' && (patientType === 'IP' || patientType === 'bedside')) {
                                        filtereData[key]['disable'] = false;
                                    }
                                })
                                return false;
                            }
                        }
                    },
                    message: 'Please Enter Nurse Station'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-6'
        }, {
            id: 11,
            name: 'approched_time',
            text: 'Approched Time',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'text',
            placeholder: 'Approched Time',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        return (value !== null && value.length > 0);
                    },
                    message: 'Please Enter Your Approched Time'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-6'
        }, {
            id: 9,
            name: 'requested_time',
            text: 'Requested Time',
            visible: true,
            element: 'timepicker',
            required: true,
            input_type: 'date',
            placeholder: 'Requested Time',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        //return (value !== null && value.length > 0);
                        return true;
                    },
                    message: 'Please Select Requested Time'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-6'
        }, {
            id: 10,
            name: 'reason',
            text: 'Reason',
            visible: true,
            element: 'select2',
            required: true,
            input_type: 'select',
            placeholder: 'Reason',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        //return (value !== null && value.length > 0);
                        return true;
                    },
                    message: 'Please Select Your Reason'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-12'
        }, {
            id: 12,
            name: 'appointment_time',
            text: 'Appointment Time',
            visible: true,
            element: 'timepicker',
            required: true,
            input_type: 'date',
            placeholder: 'Appointment Time',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        return (value !== null && value.length > 0);
                    },
                    message: 'Please Select Appointment Time'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-6'
        }
    ]
})



let dissableFormData = Object.freeze({
    "feilds": [
        {
            id: 5,
            name: 'date',
            text: 'Date',
            visible: true,
            element: 'date',
            required: true,
            input_type: 'date',
            placeholder: 'Select Date',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        return (value !== null && value.length > 0);
                    },
                    message: 'Please Select Your Appointment Date'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col'
        }, {
            id: 6,
            name: 'from',
            text: 'start Time',
            visible: true,
            element: 'timepicker',
            required: true,
            input_type: 'date',
            placeholder: 'Start Time',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        return (value !== null && value.length > 0);
                    },
                    message: 'Please Select start Time'
                }, {
                    verify: (dissableFormData) => {
                        let data = false;
                        if (dissableFormData !== undefined) {
                            dissableFormData.map((feild, key) => {

                                if (feild.name === 'date' && feild.value !== null) {
                                    data = true;
                                }

                            })
                            if (data) {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    },
                    message: 'Please Select Start Time'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col'
        }, {
            id: 7,
            name: 'to',
            text: 'End Time',
            visible: true,
            element: 'timepicker',
            required: true,
            input_type: 'date',
            placeholder: 'End Time',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        return (value !== null && value.length > 0);
                    },
                    message: 'Please Select End Time'
                }, {
                    verify: (dissableFormData) => {
                        let data = false;
                        if (dissableFormData !== undefined) {
                            dissableFormData.map((feild, key) => {

                                if (feild.name === 'date' && feild.value !== null) {
                                    data = true;
                                }

                            })
                            if (data) {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    },
                    message: 'Please Select End Time'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col'
        }
    ]
})

export { filter, formData, dissableFormData };